<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-task-timer-presenter
[items]="items$ | async"
[timerHistory]="timerHistory$ | async"
[userInfo]="userInfo$ | async"
(StartTimer)="onStartTimer($event)"
(StopTimer)="onStopTimer($event)"
(UpdateTimerHistory)="onUpdateTimerHistory($event)"
(LoadTimerHistory)="onLoadTimerHistory($event)"
>
</ef-task-timer-presenter>
